import { useRef } from "react";
import { QRCodeSVG } from "qrcode.react";
import { Button } from "./ui/button";
import { Download, QrCode } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useAppConfig } from "../lib/AppConfigContext";

export function VotingQRCode({ url, title = "Consulta", size = 200 }) {
  const qrRef = useRef(null);
  const { t } = useTranslation();
  const { appName } = useAppConfig();

  const handleDownload = () => {
    const svg = qrRef.current?.querySelector("svg");
    if (!svg) return;

    // Create canvas
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const padding = 40;
    const textHeight = 60;
    
    canvas.width = size + padding * 2;
    canvas.height = size + padding * 2 + textHeight;

    // White background
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Convert SVG to image
    const svgData = new XMLSerializer().serializeToString(svg);
    const svgBlob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
    const svgUrl = URL.createObjectURL(svgBlob);

    const img = new Image();
    img.onload = () => {
      // Draw QR code centered
      ctx.drawImage(img, padding, padding, size, size);

      // Add title text
      ctx.fillStyle = "#1e293b";
      ctx.font = "bold 16px Inter, system-ui, sans-serif";
      ctx.textAlign = "center";
      
      // Truncate title if too long
      let displayTitle = title;
      if (displayTitle.length > 35) {
        displayTitle = displayTitle.substring(0, 32) + "...";
      }
      ctx.fillText(displayTitle, canvas.width / 2, size + padding + 30);

      // Add app branding
      ctx.fillStyle = "#64748b";
      ctx.font = "12px Inter, system-ui, sans-serif";
      ctx.fillText(`${appName} - ${t('consultaDetail.secureVoting')}`, canvas.width / 2, size + padding + 50);

      // Download
      const link = document.createElement("a");
      link.download = `qr-votacio-${title.replace(/[^a-zA-Z0-9]/g, "-").toLowerCase()}.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();

      URL.revokeObjectURL(svgUrl);
    };
    img.src = svgUrl;
  };

  return (
    <div className="flex flex-col items-center gap-4">
      <div 
        ref={qrRef}
        className="bg-white p-4 rounded-lg border border-slate-200 shadow-sm"
      >
        <QRCodeSVG
          value={url}
          size={size}
          level="H"
          includeMargin={false}
          bgColor="#ffffff"
          fgColor="#1e293b"
        />
      </div>
      <Button
        variant="outline"
        size="sm"
        onClick={handleDownload}
        className="flex items-center gap-2"
        data-testid="download-qr-btn"
      >
        <Download className="h-4 w-4" />
        {t('consultaDetail.downloadQr')}
      </Button>
    </div>
  );
}

export function VotingQRCodeCompact({ url, size = 120 }) {
  return (
    <div className="bg-white p-2 rounded border border-slate-200">
      <QRCodeSVG
        value={url}
        size={size}
        level="M"
        includeMargin={false}
        bgColor="#ffffff"
        fgColor="#1e293b"
      />
    </div>
  );
}
